import { useMainSelector } from '../../useMainSelector';

export const useBlocks = () => {
  const {
    designer: { blocks, newBlock, selectedBlock },
  } = useMainSelector();

  return { selectedBlock, blocks, newBlock };
};
